import React, { useState } from "react";
import { Drawer, FloatButton } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const CustomThemeDrawer = ({ title, children, showDrawer, onClose, open,width }) => {
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <>
     <div className={`${isdarkMode ? "my-drawer-body " : "whitemode"} `}>
      {/* <FloatButton
        tooltip={<div >Filter Data</div>}
        icon={<SettingOutlined />}
        onClick={showDrawer}
        type="primary" 
      />  */}
      <Drawer
      title={
        <span className={isdarkMode ? 'drawer-title-dark ' : 'drawer-title-light'}>
          {title}
        </span>
      }
        placement="right"
        onClose={onClose}
        open={open}
        width={width? width:500}
        className={` ${isdarkMode ? "my-drawer-body anticon-close" : "#000000"} `}
       
      >
        {children}
      </Drawer>
     </div>
    </>
  );
};

export default CustomThemeDrawer;
